export const getEventColor = (status: string) => {
  switch (status) {
    case "available":
      return {
        background: "bg-card",
        dropdownBg: "bg-card",
        text: "text-accent-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-accent-foreground text-primary",
        border: "border-l-green-800/75",
      };
    case "expired":
      return {
        dropdownBg: "bg-card",
        background: "bg-card",
        text: "text-muted-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-accent-foreground text-primary",
        border: "border-l-muted",
      };
    case "booked":
      return {
        dropdownBg: "bg-card",
        background: "bg-card",
        text: "text-accent-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-accent-foreground text-primary",
        border: "border-l-accent-foreground/75",
      };
    case "booked_by_others":
      return {
        dropdownBg: "bg-card",
        background: "bg-card",
        text: "text-muted-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-accent-foreground text-primary",
        border: "border-l-blue-600/30",
      };
    case "unavailable":
      return {
        dropdownBg: "bg-card",
        background: "bg-card",
        text: "text-muted-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-red-500 text-white border-red-500",
        border: "border-l-red-500/75",
      };
    default:
      return {
        dropdownBg: "bg-card",
        background: "bg-card",
        text: "text-muted-foreground",
        hoverBg: "hover:bg-accent hover:text-accent-foreground",
        badge: "bg-muted/20 text-muted-foreground border-muted/30",
        border: "border-l-muted",
      };
  }
};
